import { useMediaQuery, useTheme } from '@mui/material'

export const useIsLg = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up('lg'))
}
